// Mappa nome-control (dal manifest PanelDesigner) → MIDI CC del firmware BLACKWAVE.
// I nomi del pannello NON coincidono con le costanti firmware, quindi serve questo
// alias esplicito. CC presi da paramCc/switchCc (midi_handlers.cpp).
// type: 'pot' (0..127 continuo) | 'switch' (0/127). bipolar: pot con detent centrale
// (center 64 = nessun effetto), usato dai dosatori del mod source e dall'EG amount.
// I control senza voce qui (es. VOLUME master, FN) non inviano CC.

export const BLACKWAVE_CC_MAP = {
  // --- Pot (knob) ---
  VCO_WAVE: { cc: 24, type: "pot" },
  VCO_FREQ: { cc: 25, type: "pot" },
  TRACK: { cc: 26, type: "pot" }, // firmware TRACK (pot idx 6)
  NOISE: { cc: 108, type: "pot" }, // firmware NOISE (pot idx 18)
  VCO_BEAT: { cc: 109, type: "pot" }, // firmware BEAT
  RESONANCE: { cc: 30, type: "pot" },
  EG_AMOUNT: { cc: 31, type: "pot", bipolar: true }, // firmware EGAMOUNT
  CUTOFF: { cc: 111, type: "pot" },
  MOD_WAVE: { cc: 22, type: "pot", bipolar: true },
  MOD_VCO: { cc: 23, type: "pot", bipolar: true },
  MOD_VCF: { cc: 107, type: "pot", bipolar: true },
  MOD_SOURCE: { cc: 20, type: "pot" },
  MOD_RATE: { cc: 27, type: "pot" },
  GLIDE: { cc: 21, type: "pot" },
  VOLUME_VCO1: { cc: 110, type: "pot" }, // firmware VOLUME_1
  VOLUME_VCO2: { cc: 106, type: "pot" }, // firmware VOLUME_2
  // EG1 = inviluppo VCA, EG2 = inviluppo VCF (coerente con EG1_LOOP→VCALOOP, EG2_LOOP→VCFLOOP)
  EG1_ATTACK: { cc: 113, type: "pot" }, // EGVCA_A
  EG1_DECAY: { cc: 28, type: "pot" }, // EGVCA_D
  EG1_SUSTAIN: { cc: 105, type: "pot" }, // EGVCA_S
  EG1_RELEASE: { cc: 104, type: "pot" }, // EGVCA_R
  EG2_ATTACK: { cc: 112, type: "pot" }, // EGVCF_A
  EG2_DECAY: { cc: 29, type: "pot" }, // EGVCF_D
  EG2_SUSTAIN: { cc: 102, type: "pot" }, // EGVCF_S
  EG2_RELEASE: { cc: 103, type: "pot" }, // EGVCF_R
  // VOLUME (master analogico) → nessun CC

  // --- Switch ---
  VELOCITY: { cc: 85, type: "switch" },
  LEGATO: { cc: 86, type: "switch" },
  EG1_LOOP: { cc: 88, type: "switch" }, // VCALOOP
  EG2_LOOP: { cc: 87, type: "switch" }, // VCFLOOP
  DUO: { cc: 89, type: "switch" },
  ONESHOT: { cc: 90, type: "switch" }, // MODONESHOT
  MOD_SYNC: { cc: 114, type: "switch" }, // MODSYNC
  VCO_GATESYNC: { cc: 115, type: "switch" }, // VCOGATESYNC
  "MODVCO_1+2": { cc: 116, type: "switch" }, // MODVCO
  // inverted: il firmware legge questi due switch active-high (senza '!', vedi
  // readSwitches in global.cpp), quindi manda il CC con polarita' opposta agli altri
  // switch. L'audio a valle si compensa: NON si tocca il firmware, si inverte solo la
  // rappresentazione nell'editor (invio + ricezione CC) cosi' il toggle combacia con
  // la posizione fisica.
  VCO2_SYNC: { cc: 117, type: "switch", inverted: true }, // VCO2SYNC
  VCO2_WAVE_SW: { cc: 118, type: "switch", inverted: true }, // VCO2WAVE
  VCO_SHIFT: { cc: 119, type: "switch" }, // SHIFT
  MOD_GATESYNC: { cc: 14, type: "switch" }, // MODGATESYNC
  // FN → nessun CC (mai controllabile via MIDI)
};

// CC → nome control (per il CC-in dal device: sposta il knob giusto)
export const BLACKWAVE_CC_TO_NAME = Object.fromEntries(
  Object.entries(BLACKWAVE_CC_MAP).map(([name, m]) => [m.cc, name])
);
